import useApiHelpers from './helpers';

const { getRequest } = useApiHelpers();

export default function useIdentityQueueEndpoints() {
  const getPendingIdentityDocuments = async () => {
    const maxRepollAttempts = 3;
    let attempts = 0;
    let response;
    let checkInterval;

    response = await getRequest('/kyc/queue');

    if (response?.data?.rel?.repoll && attempts < maxRepollAttempts) {
      attempts += 1;
      checkInterval = setTimeout(async () => {
        response = await getRequest('/kyc/queue');
      }, 250);
    } else {
      clearTimeout(checkInterval);
      return response;
    }
  };

  const getTinCountries = async () => {
    try {
      const response = await getRequest('/kyc/tin-types');
      const tinTypes = response?.data?.tinTypes || {};
      const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

      return Object.entries(tinTypes).map(([code, data]) => ({
        code,
        name: regionNames.of(code),
        ...data,
      }));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch TIN types', e);
      return [];
    }
  };

  return {
    getPendingIdentityDocuments,
    getTinCountries,
  };
}
